import {User} from "./user.model";
import {BCategory} from "./b-category.model";
import {BPostAttachment} from "./b-post-attachment.model";

export interface IBPost {
  id?: number,
  title?: string,
  description?: string,
  tags?: string,
  imagePost?: string,
  createdAt?: Date,
  publishedAt?: Date,
  published?: boolean,
  author?: User,
  blogCategory?: BCategory,
  bPostAttachments?: BPostAttachment[]
}

export class BPost implements IBPost {
  constructor(
    public id?: number,
    public title?: string,
    public description?: string,
    public tags?: string,
    public imagePost?: string,
    public createdAt?: Date,
    public publishedAt?: Date,
    public published?: boolean,
    public author?: User,
    public blogCategory?: BCategory,
    public bPostAttachments?: BPostAttachment[]
  ) {
    this.id = id;
    this.title = title;
    this.description = description;
    this.tags = tags;
    this.imagePost = imagePost;
    this.createdAt = createdAt;
    this.publishedAt = publishedAt;
    this.published = published;
    this.author = author;
    this.blogCategory = blogCategory;
    this.bPostAttachments = bPostAttachments;
  }
}
